// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"3690":"e5ed626e","5006":"d8dfc671"}[chunkId] + ".js";
};